<div class="h-[60px] flex items-center justify-end px-4 bg-gray-50 border-b shadow-xl border-cinza">
  <!-- <h1>Header</h1> -->
  <app-avatar></app-avatar>
</div>
